module.exports = __webpack_public_path__ + "static/media/download.31e7edf7.svg";